import styled from 'styled-components';
import COLORS from '../../utils/Colors';

interface Props {
    completed: number;
    bgColour: string;
}

export const Container = styled.div`
    height: 0.4rem;
    width: 100%;
    align-items: center;
    background-color: ${COLORS.hsl00000090};
    border-radius: 10px;
`;

export const Filler = styled.div<Props>`
    height: 100%;
    width: ${props => props.completed}%;
    background-color: ${props => props.bgColour};
    border-radius: inherit;
`;
